import { z } from "zod";
import { emailField, passwordField } from "@/validation/primitives";

export const signupSchema = z.object({
  email: emailField,
  password: passwordField,
});

export type SignupFormValues = z.infer<typeof signupSchema>;
